<template>
    <section class="news">
        <section class="news__top">
            <img
                src="../../../../../assets/icons/panel/home/news.svg"
                class="news__icon"
            />
            <span class="news__title">{{$t('com.file.news.news-title')}}</span>
        </section>
        <section class="news-wrapper">
            <BulletinItem :data="bulletin" backgroundcolor="#f0f8ff" withbutton="true" />
            <section v-for="item in news" :key="item.id">
                <Information :data="item" />
            </section>
        </section>
    </section>
</template>

<script>
import Information from "./Information.vue";
import BulletinItem from "../../Communication/Bulletin/Parts/BulletinItem.vue"
import NewsService from "../../../../../services/news.service";
import BulletinService from "../../../../../services/bulletin.service";
export default {
    name: "News",
    data() {
        return {
            news: [],
            bulletin: {
                id: 0,
                title: "",
                number: "",
                link: "",
                clicks: 0
            },
        };
    },
    async mounted() {
        await this.loadData();
    },
    methods: {
        async loadData() {
            try {
                this.$store.commit("showLoader");
                await this.getLatestBulletinItem();
                await this.getNews(0);

            } catch (e) {
                if (e.response.status == 404) {
                    this.$router.push({ name: 'notfoundpage', params: { pathMatch: 'news' } });
                } else if (e.response.status == 401) {
                    this.$router.push({ name: 'Login' });
                }
            } finally {
                this.$store.commit("hideLoader");
            }
            
        },
        async getLatestBulletinItem() {
            let response = await BulletinService.getLatestBulletinItem();
            if (response.status !== 200) {
                throw await Promise.reject(response);
            }

            this.bulletin = response.data;
        },
        async getNews(value) {
            let response = await NewsService.getNews(value);
                
            if (response.status !== 200) {
                throw await Promise.reject(response);
            }

            this.news = response.data;
        },
    },
    components: {
        Information,
        BulletinItem
    },
};
</script>

<style lang="scss" scoped>
@use "../../../../../assets/scss/breakpoints.scss" as *;

    .news {
        background: #ffffff;
        border: 1px solid #dce4ee;
        box-sizing: border-box;
        border-radius: 12px;
        padding: 23px 0px;
        max-width: 485px;
        max-height: 570px;

        @media only screen and (max-width:1850px) {
            margin-top: 0px;
        }

        &__top {
            display: flex;
            align-items: center;
            padding: 0px 29px;
            padding-bottom: 20px;
            border-bottom: 1px solid #dce4ee;
        }

        &__icon {
            width: 18px;
            height: 18px;
            margin-right: 13px;
        }

        &__title {
            font-weight: 600;
            font-size: 18px;
            line-height: 132%;
            color: #00082c;
        }
    }

    .news-wrapper {
        max-height: 460px;
        overflow-y: scroll;

        &::-webkit-scrollbar {
            width: 12px;
            height: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #b5b8bd;
            border-radius: 30px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: #b5b8bd;
        }

        &::-webkit-scrollbar-track {
            background: #ffffff;
            border: 0.8px solid #dce4ee;
            border-radius: 30px;
            box-shadow: inset 0px 0px 0px 0px #f0f0f0;
        }
    }
</style>
